// src/components/ArcGISMap.js
import React from 'react';

const ArcGISMap = ({ itemId, portalUrl, theme, title, description }) => (
  <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
    <div className="flex items-center justify-between mb-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
      </div>
    </div>
    <arcgis-embedded-map
      style={{ height: '600px', width: '100%' }}
      item-id={itemId}
      theme={theme}
      portal-url={portalUrl}
      legend-enabled
    ></arcgis-embedded-map>
  </div>
);

export default ArcGISMap;